/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import * as React from 'react';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useDispatch } from 'react-redux';
import { isWeb, isMobileWeb } from '@global/screens';
import { setTitleHeader, setDefaultStackOption } from '@global/helpers';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import BackButton from '@components/navbar/BackButton';
import CustomerRegistrationScreen from '@/screens/customer/registration/CustomerRegistrationScreen';

const Stack = createStackNavigator();

const CustomerRegisterNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();
  const dispatch = useDispatch();
  return (
    <Stack.Navigator
      initialRouteName="CustomerRegistrationScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}
      // listeners={({ navigation }) => ({
      //     state: (e) => {
      //         console.log('state changed ', e.data);
      //         console.log('navigation ', navigation);
      //     },
      // })}
    >
      <Stack.Screen
        name="CustomerRegistrationScreen"
        component={CustomerRegistrationScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Customer Registration';
          if (route.params && route.params.name && !(isWeb && !isMobileWeb)) {
            title = route.params.name;
          }
          return {
            title: setTitleHeader(title),
          };
        }}
        // listeners={({ navigation, route }) => ({
        //   blur: (e) => {
        //     // Prevent default action
        //     //e.preventDefault();
        //     // navigation.dispatch(CommonActions.setParams({
        //     //     id: undefined
        //     // }));
        //     // console.log('state changed ', e);
        //     // console.log('route ', route);
        //     // console.log('navigation ', navigation);
        //     // navigation.setParams({
        //     //     id: undefined
        //     // })
        //   },
        // })}
      />
    </Stack.Navigator>
  );
};

export default CustomerRegisterNavigator;
